import React, { useState, useEffect } from 'react';
import './achievements.scss';
import { easeInOut, motion } from 'framer-motion';
import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor, client } from '../../client';
import {AiFillEye, AiFillGithub} from "react-icons/ai";

function Achievements() {
  const [achievement, setAchievements] = useState([]);
    const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });
    const [showModal, setShowModal] = useState(false);
    const [modalLink,setModalLink] = useState('');

  useEffect(() => {
    const achievementsQuery = `*[_type == "achievements"]{
      name,
      description,
      "image":image.asset->url,
    }`
    client.fetch(achievementsQuery).then((data) => {
      
      console.log("acfc",data)
      setAchievements(data);
    });
  }, []);

  // JSX rendering
  return (
    <div>
      <h2 className="head-text">Achievements</h2>
      <motion.div
          animate={animateCard}
          transition={{ duration: 0.5, delayChildren: 0.5 }}
          className="app__work-portfolio"
      >
          {
              showModal && <div style={{backgroundColor:'rgba(0,0,0,0.4)',width:'100%',height:'100%',position:'fixed',top:0}}/>

          }
          {
              showModal && <div style={{width:'80vw',height:'80vh',position:'fixed',top:'10%',zIndex:'10',backgroundColor:'#fff'}}>
                  <img src={modalLink} alt="" height={'100%'}/>
                    <div style={{position:'absolute',right:30,top:10,cursor:'pointer'}} onClick={()=>{setShowModal(false)}}>X</div>

              </div>
          }


      {achievement.map((work, index) => (
          <div className="app__work-item app__flex" key={index}>
            <div
                className="app__work-img app__flex"
            >
              <img src={work.image} alt={work.name} />

              <motion.div
                  whileHover={{ opacity: [0, 1] }}
                  transition={{ duration: 0.25, ease: 'easeInOut', staggerChildren: 0.5 }}
                  className="app__work-hover app__flex"
              >
                <a href={work.projectLink} target="_blank" rel="noreferrer">

                  <motion.div
                      whileInView={{ scale: [0, 1] }}
                      whileHover={{ scale: [1, 0.90] }}
                      transition={{ duration: 0.25 }}
                      className="app__flex"
                      onClick={()=>{
                          setModalLink(work.image)
                          setShowModal(true)
                      }}
                  >
                    <AiFillEye />
                  </motion.div>
                </a>
                {/*<a href={work.codeLink} target="_blank" rel="noreferrer">*/}
                {/*  <motion.div*/}
                {/*      whileInView={{ scale: [0, 1] }}*/}
                {/*      whileHover={{ scale: [1, 0.90] }}*/}
                {/*      transition={{ duration: 0.25 }}*/}
                {/*      className="app__flex"*/}
                {/*  >*/}
                {/*    <AiFillGithub />*/}
                {/*  </motion.div>*/}
                {/*</a>*/}
              </motion.div>
            </div>

            <div className="app__work-content app__flex">
              <h4 className="bold-text">{work.name}</h4>
              <p className="p-text" style={{ marginTop: 10 }}>{work.description}</p>

              <div className="app__work-tag app__flex">
                <p className="p-text">{work && work.tags && work.tags.join(",")}</p>
              </div>
            </div>
          </div>
      ))}
      </motion.div>

    </div>
  );
}

export default AppWrap(
  MotionWrap(Achievements, 'app__achievement'),
  'achievements',
  'app__whitebg',
);
